import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type OpenAssetModalLocations } from '../types';

export type TrackOpenedAssetModal = {
  location: OpenAssetModalLocations;
  rank?: number;
};

export const useTrackOpenedAssetModal = () => {
  const { track } = useAnalyticsUtilities();

  const trackOpenedAssetModal = useCallback(
    (params: TrackOpenedAssetModal) => {
      track(`Opened asset details modal`, params);
    },
    [track],
  );

  return { trackOpenedAssetModal };
};
